import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';


export const useConfigStore = defineStore('config', {
    state: () => ({
        sidebarMiniActive: useStorage('sidebarMiniActive', false),
    }),

    getters: {
        getSidebarMiniStatus: (state) => state.sidebarMiniActive,
    },
    actions: {
        toggleSidebarMini() {
            this.sidebarMiniActive = !this.sidebarMiniActive;
        }
    },
});
